import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import CheckImport from './CheckImport'

export default [
    { path: 'checkimport', component: CheckImport, beforeEnter: AdminGuard, name: 'checkimport', meta: { title: 'Cek import' } },
]
